import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search, X } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { HubCard, HUB_ROUTES } from './HubDashboard';

const TOOLS = [
  ['Nuevo Contrato', '/discovery'], ['Plantillas', '/templates'], ['Mis Plantillas', '/my-templates'], ['Actualidad Jurídica', '/legal-feed'],
  ['Proteger Contrato', '/proteger-contrato'], ['Comparar Contratos', '/comparar-contratos'], ['Historial de análisis', '/historial-proteccion'],
  ['Consejero Legal', '/consejero-legal'], ['Contabilidad IA', '/contabilidad'], ['Plazos Legales', '/plazos-legales'],
  ['Calculadora Laboral / Finiquitos', '/calculadora-laboral'], ['Jurisprudencia', '/jurisprudencia'], ['Escritos Judiciales', '/escritos-legales'],
  ['Poder Judicial', '/poder-judicial'], ['Firma Electrónica', '/firma-electronica'], ['Inteligencia Judicial', '/inteligencia-judicial'],
  ['Expertos Notariales', '/expertos-notariales'], ['CRM - Mis casos', '/crm'], ['Calendario de Plazos', '/calendario-plazos'],
  ['Constituir Empresa', '/constituir-empresa'], ['Negociación IA', '/negociacion'], ['Alertas', '/alertas'], ['Mi Perfil Notarial', '/mi-perfil'],
  ['Panel Admin', '/admin'], ['Ordenamiento jurídico por país (Constitución, códigos, leyes)', '/legal-feed?tab=ordenamiento'], ['Congreso y proyectos de ley', '/legal-feed?tab=congreso'], ['Comparador de países (derecho comparado)', '/legal-feed?tab=comparador'], ['Hub de Familia', '/hub-familia'], ['Agentes Especialistas IA', '/agentes-especialistas'],
].map(([name, route]) => ({ id: `tool-${route.slice(1)}`, name, route, description: 'Herramienta del Dashboard', profile: 'Herramienta' }));

const norm = (s) => (s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

export const HubSearch = ({ profiles }) => {
  const { api } = useAuth();
  const navigate = useNavigate();
  const [q, setQ] = useState('');
  const [hubs, setHubs] = useState([]);

  useEffect(() => {
    if (!profiles.length) return;
    Promise.all(profiles.map((p) => api.get(`/platform/profiles/${p.type}/hubs`)
      .then((r) => r.data.hubs.map((h) => ({ ...h, route: HUB_ROUTES[h.id], profile: p.name })))
      .catch(() => [])))
      .then((lists) => {
        const byId = {};
        lists.flat().forEach((h) => { byId[h.id] = byId[h.id] ? { ...byId[h.id], profile: `${byId[h.id].profile}, ${h.profile}` } : h; });
        setHubs(Object.values(byId));
      });
  }, [api, profiles]);

  const results = useMemo(() => {
    const t = norm(q.trim());
    if (!t) return [];
    return [...hubs, ...TOOLS].filter((h) => norm(`${h.name} ${h.description} ${(h.features || []).join(' ')} ${h.profile}`).includes(t)).slice(0, 12);
  }, [q, hubs]);

  return (
    <div className="mb-6">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-500" />
        <input data-testid="hub-search-input" value={q} onChange={(e) => setQ(e.target.value)}
          placeholder="Buscar cualquier Hub o función: tributario, alimentos, finiquito, escrituras…"
          className="w-full rounded-xl border border-slate-700 bg-slate-950/60 py-3 pl-10 pr-10 text-sm text-white placeholder:text-slate-500 focus:border-blue-400 focus:outline-none" />
        {q && <button data-testid="hub-search-clear" onClick={() => setQ('')} className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-500 hover:text-white"><X className="h-4 w-4" /></button>}
      </div>
      {q.trim() && (
        <div data-testid="hub-search-results" className="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-3">
          {results.length === 0 && <p data-testid="hub-search-empty" className="text-sm text-slate-400">Sin resultados para «{q}».</p>}
          {results.map((h) => (
            <div key={h.id}>
              <HubCard hub={h} size="small" onClick={() => navigate(h.route || '/dashboard')} />
              <p className="mt-1 px-1 text-[11px] text-slate-500">{h.profile}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
